import { Outlet } from '@tanstack/react-router'
import { Main } from '@/components/layout/main'
import { UnifiedHeader } from '@/components/layout/unified-header'

export function FlashSalesInventoryLayout() {
  return (
    <>
      <UnifiedHeader />
      <Main>
        <Outlet />
      </Main>
    </>
  )
}
